// extracted by mini-css-extract-plugin
export default {"root":"cxt9uBxh0Y","root_hasBackground":"fyfceb21Kw","root_mobile":"qOa6EL5zmU","button":"r5vV2gt0tk","img":"OCgw64l109"};